// components/ProductList.js
import React, { useState, useEffect } from "react";
import Modal from "./Modal.jsx";
import Pagination from "./Pagination.jsx";
import "../../styles/home.css";
import "../../styles/shared.css";
import Footer from "../common/Footer.jsx";
import Navbar from "../common/Navbar.jsx";
import { useNavigate } from "react-router-dom";

const ProductList = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/api/products`
      );
      if (response.ok) {
        const data = await response.json();
        setProducts(data);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const handleDelete = async (productId) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      try {
        const response = await fetch(
          `${import.meta.env.VITE_API_URL}/api/products/${productId}`,
          {
            method: "DELETE",
          }
        );

        if (response.ok) {
          await fetchProducts();
          setIsModalOpen(false);
        }
      } catch (error) {
        console.error("Error deleting product:", error);
      }
    }
  };
  const handleAvailabilityToggle = async (productId, currentAvailability) => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/api/products/${productId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            availability:
              currentAvailability === "available" ? "unavailable" : "available",
          }),
        }
      );

      if (response.ok) {
        await fetchProducts(); // Refresh the products list
      }
    } catch (error) {
      console.error("Error updating availability:", error);
    }
  };

  // Pagination calculations
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentProducts = products.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(products.length / itemsPerPage);

  return (
    <div>
      <Navbar />
      <div className="product-list">
        <h2 className="hTitle">Our Products</h2>
        <div className="grid-container">
          {currentProducts.map((product) => (
            <div
              key={product._id}
              className="item-card"
              onClick={() => {
                setSelectedProduct(product);
                setIsModalOpen(true);
              }}
            >
              <img
                src={`${import.meta.env.VITE_API_URL}/${product.image1}`}
                alt={product.name}
                className="item-image"
              />
              <div className="product-info">
                <h3>{product.name}</h3>
                <p>{product.Brand}</p>
                <p className="price">{product.price}Fbu</p>
                <p>Stock: {product.Quantity}</p>
              </div>
            </div>
          ))}
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />

        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          {selectedProduct && (
            <div className="product-details">
              <div className="image-gallery">
                <img
                  src={`${import.meta.env.VITE_API_URL}/${selectedProduct.image1}`}
                  alt={selectedProduct.name}
                  className="item-image"
                />
                <img
                  src={`${import.meta.env.VITE_API_URL}/${selectedProduct.image2}`}
                  alt={selectedProduct.name}
                  className="item-image"
                />
              </div>

              <div className="detail-grid">
                <div className="detail-item">
                  <div className="detail-label">Name:</div>
                  <div>{selectedProduct.name}</div>
                </div>
                <div className="detail-item">
                  <div className="detail-label">Brand:</div>
                  <div>{selectedProduct.Brand}</div>
                </div>
                <div className="detail-item">
                  <div className="detail-label">Category:</div>
                  <div>{selectedProduct.category}</div>
                </div>
                <div className="detail-item">
                  <div className="detail-label">Price:</div>
                  <div>{selectedProduct.price}Fbu</div>
                </div>
                <div className="detail-item">
                  <div className="detail-label">Quantity:</div>
                  <div>{selectedProduct.Quantity}</div>
                </div>
                <div className="detail-item">
                  <div className="detail-label">Seller Code:</div>
                  <div>{selectedProduct.sellercode}</div>
                </div>
              </div>
              <p
                className={`availability ${
                  selectedProduct.availability === "available"
                    ? "available"
                    : "unavailable"
                }`}
              >
                {selectedProduct.availability === "available"
                  ? "Available"
                  : "Not Available"}
              </p>

              <div className="details-section">
                <div className="detail-label">Details:</div>
                <p>{selectedProduct.Details}</p>
              </div>
              <div className="detail-item">
                <div className="detail-label">Availability:</div>
                <div className="availability-control">
                  <span
                    className={`status-badge ${
                      selectedProduct.availability === "available"
                        ? "available"
                        : "unavailable"
                    }`}
                  >
                    {selectedProduct.availability === "available"
                      ? "Available"
                      : "Unavailable"}
                  </span>
                  <button
                    className="toggle-btn"
                    onClick={() =>
                      handleAvailabilityToggle(
                        selectedProduct._id,
                        selectedProduct.availability
                      )
                    }
                  >
                    Toggle Availability
                  </button>
                </div>
              </div>
              <div className="button-group">
                <button
                  className="button button-primary"
                  onClick={() =>
                    navigate(`/products/edit/${selectedProduct._id}`)
                  }
                >
                  Modify
                </button>
                <button
                  className="button button-danger"
                  onClick={() => handleDelete(selectedProduct._id)}
                >
                  Delete
                </button>
              </div>
            </div>
          )}
        </Modal>
      </div>
      <Footer />
    </div>
  );
};

export default ProductList;
